/**
 * 搜索推荐
 * 
 * @Author: Focci
 * @Date: 2023-08-05 10:05:53
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-05 10:05:53
 */

'use client'

import PropTypes from 'prop-types'
import { isFunction, filter } from 'lodash-es'
import { useCallback } from 'react'
import HistoryRecording from './HistoryRecording'
import SearchRecommend from './SearchRecommend'

export default function SearchSuggestion({
  inputValue = [],
  inputValueSetter = () => {},
  isMapListing,
  type,
  onChange,
  handleItem
}) {
  const handleChange = useCallback((args) => {
    isFunction(inputValueSetter) && inputValueSetter((prev) => {
      const { id, type: typ, name, slug } = args.chip || {}
      const tmp = [
        ...filter(prev, (f) => !(f.type === typ && f.value === id) 
          && ['school', 'street'].indexOf(f.type) === -1),
        { label: name, htmlLabel: name, value: id, type: typ, slug }
      ]

      isFunction(onChange) && onChange(args, tmp)
      return tmp
    })
  }, [onChange, inputValueSetter])

  // https://7thave.atlassian.net/browse/HT-4281
  // https://7thave.atlassian.net/browse/HT-4141?focusedCommentId=17112
  // https://7thave.atlassian.net/browse/HT-4944
  // if(type === houseSearchType.estimate) {
  //   return null
  // }

  return (
    <div className="flex flex-col gap-4 w-full overflow-auto">
      <SearchRecommend
        isMapListing={isMapListing}
        disabled={inputValue}
        type={type} 
        onChange={handleChange} 
      />
      <HistoryRecording type={type} handleItem={handleItem} />
    </div>
  )
}

SearchSuggestion.propTypes = {
  type: PropTypes.string,
  onChange: PropTypes.func,
}
